var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.mini)?_c('div',{class:{ 'bg-success' : _vm.status, 'bg-danger': !_vm.status }}):_c('h4',[_c('small',{staticClass:"badge badge-pill",class:_vm.status ? 'badge-success' : 'badge-danger'},[_vm._v("\n    "+_vm._s(_vm.status ? _vm.ativoText : _vm.inativoText)+"\n  ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }